import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  TableCell,
  Typography,
} from '@material-ui/core'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'

import { IAccordionItemProps } from '../../types'
import { useStyles } from './style'

const AccordionPolygons = ({ value }: IAccordionItemProps) => {
  const classes = useStyles()

  const uniquePolygons = value.matching
    .filter(
      (item, index, polygons) =>
        polygons.findIndex((i) => i.id === item.id) === index,
    )
    .sort((a, b) => a.name.localeCompare(b.name))

  const totalPolygons = uniquePolygons.length + value.unmatching

  return (
    <TableCell className={classes.accordion} colSpan={2}>
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          id='accordion'
          className={classes.accordionSummary}
        >
          <Typography className={classes.label}>Polígonos:</Typography>
          <Typography
            className={classes.title}
          >{`${totalPolygons} polígonos`}</Typography>
        </AccordionSummary>
        <AccordionDetails className={classes.accordionDetails}>
          {uniquePolygons.map((polygon) => (
            <Typography
              className={classes.accordionDetailsItem}
              key={polygon.id}
            >
              {polygon.name}
            </Typography>
          ))}
          {value.unmatching > 0 && (
            <Typography className={classes.accordionDetailsItem}>
              {value.unmatching} polígono(s) não identificado(s)
            </Typography>
          )}
        </AccordionDetails>
      </Accordion>
    </TableCell>
  )
}

export default AccordionPolygons
